import { render } from "./SecondBar.vue?vue&type=template&id=ed4202fc&scoped=true"
import script from "./SecondBar.vue?vue&type=script&lang=js"
export * from "./SecondBar.vue?vue&type=script&lang=js"

import "./SecondBar.vue?vue&type=style&index=0&id=ed4202fc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4202fc"]])

export default __exports__